import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const R5Main = lazy(() => import('../r5draft/R5Main'));
const R5LiveDraft = lazy(() => import('../r5draft/R5LiveDraft'));
const R5DraftOrder = lazy(() => import('../r5draft/R5DraftOrder'));
const R5DraftAdmin = lazy(() => import('../r5draft/R5DraftAdmin'));
const R5DraftHistory = lazy(() => import('../r5draft/R5DraftHistory'));
const R5SelectablePlayers = lazy(
  () => import('../r5draft/R5SelectablePlayers')
);
const R5ReserveLists = lazy(() => import('../r5draft/R5ReserveLists'));

export default [
  {
    id: NavConfig.groupConfigs.RULE_5.id,
    path: NavConfig.groupConfigs.RULE_5.to,
    element: (
      <R5Main>
        <Suspense>
          <Outlet />
        </Suspense>
      </R5Main>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.R5_DRAFT_ORDER.to} />,
      },
      {
        id: NavConfig.linkConfigs.R5_DRAFT_LIVE.id,
        path: NavConfig.linkConfigs.R5_DRAFT_LIVE.to,
        element: (
          <R5LiveDraft>
            <Suspense>
              <Outlet />
            </Suspense>
          </R5LiveDraft>
        ),
        children: [
          {
            id: NavConfig.linkConfigs.R5_DRAFT_ADMIN.id,
            path: NavConfig.linkConfigs.R5_DRAFT_ADMIN.to,
            element: <R5DraftAdmin />,
          },
          {
            id: NavConfig.linkConfigs.R5_DRAFT_HISTORY.id,
            path: NavConfig.linkConfigs.R5_DRAFT_HISTORY.to,
            element: <R5DraftHistory />,
          },
          {
            id: NavConfig.linkConfigs.R5_DRAFT_ORDER.id,
            path: NavConfig.linkConfigs.R5_DRAFT_ORDER.to,
            element: <R5DraftOrder />,
          },
          {
            id: NavConfig.linkConfigs.R5_RESERVE_LISTS.id,
            path: NavConfig.linkConfigs.R5_RESERVE_LISTS.to,
            element: <R5ReserveLists />,
          },
          {
            id: NavConfig.linkConfigs.R5_SELECTABLE_PLAYERS.id,
            path: NavConfig.linkConfigs.R5_SELECTABLE_PLAYERS.to,
            element: <R5SelectablePlayers />,
          },
        ],
      },
    ],
  },
];
